import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useRequest from "../../components/hooks/use-request";
import Toast, { showToast } from "../../components/toast";
import BackgroundCard from "../../components/background-card";
import Login from "../../components/auth/signin/signin";

const Signin = () => {
  const { loading, makeRequest } = useRequest("/auth/login", "POST");
  const navigate = useNavigate();
  const { handleSubmit, control, setValue } = useForm();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userInfo = JSON.parse(user);
      setValue("email", userInfo.email);
      setValue("password", userInfo.password);
    }
  }, [setValue]);

  const handleLogin = handleSubmit(async (formData) => {
    const user = {
      email: formData.email,
      password: formData.password,
    };
    const [response] = await makeRequest(user);
    if (response.status) {
      localStorage.setItem("token", response.data?.token);
      showToast(response.message, true, {
        position: "top-right",
      });
      navigate("/dashboard");
    } else {
      showToast(response?.message || "Login failed", false, {
        position: "top-right",
      });
    }
  });

  return (
    <>
      <BackgroundCard>
        <Login handleLogin={handleLogin} control={control} loading={loading} />
      </BackgroundCard>
      <Toast />
    </>
  );
};

export default Signin;
